var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-info-tile",class:_vm.tileClasses},[(_vm.hasLabel)?_c('div',{staticClass:"ui-info-tile__label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.$t(_vm.label)))]})],2):_vm._e(),_c('div',{staticClass:"ui-info-tile__value"},[_vm._t("value",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }